export const SET_KEYCLOAK_READY = "SET_KEYCLOAK_READY";
export const SET_KEYCLOAK_AUTHENTICATED = "SET_KEYCLOAK_AUTHENTICATED";
export const SET_KEYCLOAK = "SET_KEYCLOAK";
export const SET_USER_TOKEN = "SET_USER_TOKEN";
